import { render, staticRenderFns } from "./CommercialPropertiesForLease.vue?vue&type=template&id=1df49248&"
import script from "./CommercialPropertiesForLease.vue?vue&type=script&lang=ts&"
export * from "./CommercialPropertiesForLease.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports